export const playwireEnabled = () => {
  return (
    process.env.NEXT_PUBLIC_RAMP_PUB_ID &&
    process.env.NEXT_PUBLIC_RAMP_WEBSITE_ID &&
    process.env.NEXT_PUBLIC_ADS_MODE === 'playwire'
  );
};
